/**
 * E010-T017: StreamlainTextRenderer
 *
 * Extends TextRenderer with lightweight streaming support.
 * Uses MarkedStreamingRenderer during generation for instant updates.
 *
 * Note: The base TextRenderer now handles streaming natively via
 * MarkedStreamingRenderer, so this class just ensures compatibility.
 */

import { TextRenderer } from '../../blocksuite/ai/components/text-renderer';

export class StreamlainTextRenderer extends TextRenderer {
  // Base TextRenderer now handles everything via MarkedStreamingRenderer
  // No need to override anything - streaming works out of the box
}
